"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.globalHandlersIntegration = void 0;

var _core = require("@sentry/core");

var _debugBuild = require("../debug-build.js");

var _eventbuilder = require("../eventbuilder.js");

var _helpers = require("../helpers.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const INTEGRATION_NAME = 'GlobalHandlers';

const _globalHandlersIntegration = (options = {}) => {
  const _options = _objectSpread({
    onerror: true,
    onunhandledrejection: true
  }, options);

  return {
    name: INTEGRATION_NAME,

    setupOnce() {
      Error.stackTraceLimit = 50;
    },

    setup(client) {
      if (_options.onerror) {
        _installGlobalOnErrorHandler(client);

        globalHandlerLog('onerror');
      }

      if (_options.onunhandledrejection) {
        _installGlobalOnUnhandledRejectionHandler(client);

        globalHandlerLog('onunhandledrejection');
      }
    }

  };
};

const globalHandlersIntegration = exports.globalHandlersIntegration = (0, _core.defineIntegration)(_globalHandlersIntegration);

function _installGlobalOnErrorHandler(client) {
  (0, _core.addGlobalErrorInstrumentationHandler)(data => {
    const _getOptions = getOptions(),
          stackParser = _getOptions.stackParser,
          attachStacktrace = _getOptions.attachStacktrace;

    if ((0, _core.getClient)() !== client || (0, _helpers.shouldIgnoreOnError)()) {
      return;
    }

    const msg = data.msg,
          url = data.url,
          line = data.line,
          column = data.column,
          error = data.error;

    const event = _enhanceEventWithInitialFrame((0, _eventbuilder.eventFromUnknownInput)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);

    event.level = 'error';
    (0, _core.captureEvent)(event, {
      originalException: error,
      mechanism: {
        handled: false,
        type: 'onerror'
      }
    });
  });
}

function _installGlobalOnUnhandledRejectionHandler(client) {
  (0, _core.addGlobalUnhandledRejectionInstrumentationHandler)(e => {
    const _getOptions2 = getOptions(),
          stackParser = _getOptions2.stackParser,
          attachStacktrace = _getOptions2.attachStacktrace;

    if ((0, _core.getClient)() !== client || (0, _helpers.shouldIgnoreOnError)()) {
      return;
    }

    const error = _getUnhandledRejectionError(e);

    const event = (0, _core.isPrimitive)(error) ? _eventFromRejectionWithPrimitive(error) : (0, _eventbuilder.eventFromUnknownInput)(stackParser, error, undefined, attachStacktrace, true);
    event.level = 'error';
    (0, _core.captureEvent)(event, {
      originalException: error,
      mechanism: {
        handled: false,
        type: 'onunhandledrejection'
      }
    });
  });
}

function _getUnhandledRejectionError(error) {
  if ((0, _core.isPrimitive)(error)) {
    return error;
  } // dig the object of the rejection out of known event types


  try {
    // PromiseRejectionEvents store the object of the rejection under 'reason'
    // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
    if ('reason' in error) {
      return error.reason;
    } // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
    // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
    // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
    // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
    // https://github.com/getsentry/sentry-javascript/issues/2380


    if ('detail' in error && 'reason' in error.detail) {
      return error.detail.reason;
    }
  } catch (e2) {} // eslint-disable-line no-empty


  return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */


function _eventFromRejectionWithPrimitive(reason) {
  return {
    exception: {
      values: [{
        type: 'UnhandledRejection',
        // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
        value: `Non-Error promise rejection captured with value: ${String(reason)}`
      }]
    }
  };
}

function _enhanceEventWithInitialFrame(event, url, line, column) {
  // event.exception
  const e = event.exception = event.exception || {}; // event.exception.values

  const ev = e.values = e.values || []; // event.exception.values[0]

  const ev0 = ev[0] = ev[0] || {}; // event.exception.values[0].stacktrace

  const ev0s = ev0.stacktrace = ev0.stacktrace || {}; // event.exception.values[0].stacktrace.frames

  const ev0sf = ev0s.frames = ev0s.frames || [];
  const colno = column;
  const lineno = line;
  const filename = (0, _core.isString)(url) && url.length > 0 ? url : (0, _core.getLocationHref)(); // event.exception.values[0].stacktrace.frames

  if (ev0sf.length === 0) {
    ev0sf.push({
      colno,
      filename,
      function: _core.UNKNOWN_FUNCTION,
      in_app: true,
      lineno
    });
  }

  return event;
}

function globalHandlerLog(type) {
  _debugBuild.DEBUG_BUILD && _core.logger.log(`Global Handler attached: ${type}`);
}

function getOptions() {
  const client = (0, _core.getClient)();
  const options = client && client.getOptions() || {
    stackParser: () => [],
    attachStacktrace: false
  };
  return options;
}